import { api } from "../../api";
import { ApiEntityResponse } from "@ancillaries/types";
import { SettingsEntityConfig } from "./types";
import { CONTACT_ENTITIES, ContactEntityKey } from "./helpers/contacts-config";

export async function fetchList<T>(
  config: SettingsEntityConfig,
  params?: Record<string, any>,
): Promise<{ items: T[]; total: number; page: number; size: number }> {
  const { data } = await api.get(config.endpoints.list, { params });
  return data;
}

export async function fetchItem<T>(
  config: SettingsEntityConfig,
  id: number,
): Promise<T> {
  const { data } = await api.get(config.endpoints.getOne(id));
  return data;
}

export async function createItem<T>(
  config: SettingsEntityConfig,
  payload: Record<string, any>,
): Promise<T> {
  const { data } = await api.post(config.endpoints.create, payload);
  return data;
}

export async function updateItem<T>(
  config: SettingsEntityConfig,
  id: number,
  payload: Partial<T>,
): Promise<T> {
  const { data } = await api.patch(config.endpoints.update(id), payload);
  return data;
}

export async function deleteItem(
  config: SettingsEntityConfig,
  id: number,
): Promise<void> {
  await api.delete(config.endpoints.delete(id));
}

export async function restoreItem<T>(
  config: SettingsEntityConfig,
  id: number,
): Promise<T> {
  const { data } = await api.post(config.endpoints.restore(id));
  return data;
}

export async function fetchContactItemsApi<T>(
  key: ContactEntityKey,
  parentId: number,
): Promise<ApiEntityResponse<T>> {
  const { endpoints } = CONTACT_ENTITIES[key];
  const { url, params } = endpoints.fetch(parentId);
  const { data } = await api.get(url, { params });
  return data;
}

export async function createContactItemApi<T>(
  key: ContactEntityKey,
  payload: any,
): Promise<T> {
  const { endpoints } = CONTACT_ENTITIES[key];
  const { url } = endpoints.create;
  const { data } = await api.post(url, payload);
  return data;
}

export async function updateContactItemApi<T>(
  key: ContactEntityKey,
  id: number,
  payload: any,
): Promise<T> {
  const { endpoints } = CONTACT_ENTITIES[key];
  const { url } = endpoints.update(id);
  const { data } = await api.patch(url, payload);
  return data;
}

export async function deleteContactItemApi(
  key: ContactEntityKey,
  id: number,
): Promise<void> {
  const { endpoints } = CONTACT_ENTITIES[key];
  const { url, params } = endpoints.delete(id);
  await api.delete(url, { params });
}
